$(function () {
	/* ==== OPTIONS ==== */
	var $menu = $('.master-menu');              // racine du menu
	var clsExact = 'current';             // classe pour la page exacte
	var clsAncestor = 'current-ancestor'; // classe pour les sections parentes
	var locales = ['fr','en'];           // préfixes de langue à ignorer; vide [] pour désactiver

	/* ==== UTILS ==== */
	function toURL(href) {
		try { return new URL(href, window.location.origin); }
		catch (e) { return null; }
	}

	function stripLocalePrefix(path) {
		if (!locales.length) return path;
		var parts = path.split('/').filter(Boolean);
		if (parts.length && locales.indexOf(parts[0]) !== -1) parts.shift();
		return '/' + parts.join('/');
	}

	function normalize(urlObj) {
		var p = urlObj.pathname
			.replace(/\/index\.html?$/i, '/') // retire index.html
			.replace(/\/+$/, '/');            // normalise trailing slash
		if (p !== '/' && p.endsWith('/')) p = p.slice(0, -1);
		p = stripLocalePrefix(p);
		return p || '/';
	}

	function mark($a, cls) {
		$a.addClass(cls);
		$a.closest('li').addClass(cls);
	}

	/* ==== LOGIQUE ==== */
	var curURL = new URL(window.location.href);
	var curPath = normalize(curURL);


	$menu.find('a[href]').each(function () {
		var $a = $(this);
		var href = $a.attr('href');
		if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return;
		if (href == "#") return; 
		var u = toURL(href);
		if (!u || u.origin !== window.location.origin) return; // évite les liens externes

		var linkPath = normalize(u);

		// Exact match
		if (curPath === linkPath) {
			mark($a, clsExact);
			// Flag les parents comme "ancestor" pour ouvrir les sous-menus
			//$a.parents('li').addClass(clsAncestor);
		}

		// Ancêtre (évite d'activer "/" partout)
		if (linkPath !== '/' && curPath.startsWith(linkPath + '/')) {
			//mark($a, clsAncestor);
		}
	});

	
	$(".js-href").click(function(){
		return false;
	})
	if($(".current").length){
		
	}else{
		/*
		A ACTIVER COULEUR MENU ACTIVE SOUS MENU
		
		
		const currentUrl = window.location.href;
		
		let linx = $("a[href='" + window.location.href + "']");
		let par = linx.closest("[data-menu-id]");
		if(par && par.length){
			let m_target = par.attr("data-menu-id");
			$(".mm-item-link[data-menu-id]").first().addClass("current");
		}
		*/
		/*
		const currentUrl = window.location.href;
		
		let linx = $("a[href='" + window.location.href + "']");
		let par = linx.closest(".js-href");
		if(par && par.length){
			let m_target = par.attr("href");
			$(".mm-item-link[data-menu-id]").first().addClass("current");
		}
		*/
		
		

			const currentPath = window.location.pathname.replace(/\/$/, '');

			let bestMatch = null;
			let bestLength = 0;

			$('.js-href').each(function () {

				const href = $(this).attr('href');
				if (!href) return;
				if (href == "#") return;

				const linkPath = new URL(href, window.location.origin)
					.pathname
					.replace(/\/$/, '');

				if (
					currentPath.startsWith(linkPath + '/') || currentPath === linkPath
				) {
					if (linkPath.length > bestLength) {
						bestMatch = this;
						bestLength = linkPath.length;
					}
				}

			});

			if (bestMatch) {
				$(bestMatch).addClass('current');
			}




		
	}
});